import { useEffect } from 'react';
/**
 *
 * A wrapper for popups to signal popupOpen user intent
 */
export var UserIntentPopupWrapper = function UserIntentPopupWrapper(_ref) {
  var children = _ref.children,
    api = _ref.api;
  useEffect(function () {
    var _api$userIntent;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.commands.setCurrentUserIntent('popupOpen'));
    return function () {
      var _api$userIntent2;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.commands.setCurrentUserIntent('default'));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return children;
};